export default __webpack_public_path__ + "static/media/up-river.f3590dba.png";